import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { list_deptwisetemplates } from "../components/ApiProperty";
import { Listoftablesearchbox1, cancelButtonStyle, submitButtonStyle, closeButtonStyle, UploadLoadingIcon } from "../components/Propertyfile";
import { upload3001, Modifytemplate, dropdownlist } from '../components/ApiProperty';
import { Modal } from 'react-bootstrap';
import { TableHeader, tableCellStyle3, tableCellStyle4, toCamelCaseforTableProps } from "../components/TableProperty"
import { demtableattributespreview, allowmodifytemplate } from "../components/ApiProperty";
import { Button } from 'react-bootstrap';
import { BsTrash } from "react-icons/bs"; // Import the delete icon
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { FaArrowUp, FaArrowDown, FaAngleDoubleUp, FaAngleDoubleDown } from "react-icons/fa";
import { FaPlus, FaEquals } from "react-icons/fa";
import { TableTemplateListGapsy, ListofTableFontsize, PaginationComponentForm2 } from "../components/TableProperty";

import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import axios from 'axios';

const GapsyMet = () => {
    const [validErrorRecords, setvalidErrorRecords] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const location = useLocation();
    const [shouldResetOnGoBack, setShouldResetOnGoBack] = useState(true);
    const [modalMessage, setModalMessage] = useState('');
    const [filteredTables, setFilteredTables] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [Prefix, setPrefix] = useState("");
    const [tableNames, setTableNames] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(7); // Set the number of records per page
    const [modalMessageOne, setModalMessageOne] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const prefixes = Object.keys(tableNames);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [selectedName, setSelectedName] = useState('');
    const [tableColumns, setTableColumns] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [error, setError] = useState(null);
    const [selectedTableName, setSelectedTableName] = useState('');
    const [selectedFullTableName, setSelectedFullTableName] = useState('');
    const { tableHtml } = location.state || {};
    const [isFullEditMode, setIsFullEditMode] = useState(false);
    const [isFullEdit, setIsFullEdit] = useState(false);
    const [isNoEdit, setIsNoEdit] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [isTableNameEditable, setIsTableNameEditable] = useState(false);
    const [isTableNameSet, setIsTableNameSet] = useState(false);
    const [editableTableName, setEditableTableName] = useState('');
    const [tableName, setTableName] = useState('');
    const [isTableVisible, setIsTableVisible] = useState(true);
    const [isTableNameVisible, setIsTableNameVisible] = useState(true);
    const [modifyAllow, setModifyAllow] = useState('');
    const [invalidTableNameMessage, setInvalidTableNameMessage] = useState('');
    const [showNotifyModal, setShowNotifyModal] = useState(false); // State to control modal visibility
    const [notifyOption, setNotifyOption] = useState('IN'); // State for radio button selection
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const allowedTypes = ['int', 'varchar', 'date', 'double', 'boolean', 'decimal', 'float', 'char']; // Define allowed types
    const [loading, setLoading] = useState(false);
    const [isOperatorModalOpen, setIsOperatorModalOpen] = useState(false);
    const [selectedOperator, setSelectedOperator] = useState(null);

    const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]); // Tracks selected rows for edit
    const [showDeletePopup, setShowDeletePopup] = useState(false); // Controls delete confirmation popup
    const [editingColTypeRows, setEditingColTypeRows] = useState(new Set());
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [colNames, setColNames] = useState([]);
    const [selectedColName, setSelectedColName] = useState("");
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [searchText, setSearchText] = useState(""); // To filter options
    const [activeEditCell, setActiveEditCell] = useState({ rowIndex: null, columnName: null });

    const hasFetchedData = useRef(false);

    const activeStatus = localStorage.getItem("active_status");
    const templateType = localStorage.getItem("template_type");
    const stage = localStorage.getItem("stage");


    const userId = localStorage.getItem("userid");
    const department = sessionStorage.getItem("dept");

    const navigate = useNavigate();
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const handleDashboard = () => {
        navigate('/gapsyAdashboard');
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setvalidErrorRecords([]);

        try {

            const config = {
                params: { adminId: userId, dept: department },
                headers: {
                    "x-csrf-token": csrfToken
                },
                withCredentials: true,
            };

            const response = await axios.post(list_deptwisetemplates, {}, config);

            const message = "Nothing pending for Upload data";

            if (response.data?.tables?.length) {
                // Categorize tables by prefix
                const categorizedTables = {};

                response.data.tables.forEach((table) => {
                    const [prefix, ...rest] = table.split('_');
                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push(table);
                });

                setTableNames(categorizedTables);
            } else {
                setTableNames({});
                const dept = sessionStorage.getItem("dept") || "Department not found";
                const updatedMessage = `Nothing pending for Upload data in department: ${dept}`;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        if (selectedPrefix) {
            // Set the filtered tables based on selectedPrefix
            setFilteredTables(tableNames[selectedPrefix] || []);
        } else {
            setFilteredTables([]); // Clear when no prefix is selected
        }
    }, [selectedPrefix, tableNames]);

    const paginate1 = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleTableClick = async (item) => {
        if (typeof item !== 'string' || !item.includes('_')) {
            console.warn("Invalid table name:", item);
            setModalMessageOne("Invalid table name selected.");
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('param');

        setSelectedFullTableName(item);

        const [prefix, ...restParts] = item.split('_');
        const selectedNames = restParts.join('_');

        setPrefix(prefix);
        console.log("Selected Names:", selectedNames);
        console.log("Prefix:", prefix);
        setSelectedName(selectedNames);
        setvalidErrorRecords([]);
        setIsTableVisible(true);

        if (!item) {
            setSelectedFileName(null); // or clear state as needed
            return;
        }

        const selectedName = item.split('_').slice(1).join('_');

        const fileName = `${department}_${item}`;
        const config = {
            headers: {
                "userId": localStorage.getItem('userid'),
                "x-csrf-token": csrfToken
            },
            withCredentials: true,
            params: { "tableName": item, "modify": "Y" }
        };

        try {
            const response = await axios.post(allowmodifytemplate, {}, config);

            const { message, proceed } = response.data;

            if (proceed === "Yes") {
                await fetchData1(item);
            } else {

                await fetchData1(item);
            }
        } catch (error) {
            console.error("Error during table click handling:", error);
            setModalMessageOne("An error occurred. Please try again.");
        }
    };

    const filteredRecords = useMemo(() => {
        // if (!selectedPrefix) return [];
        if (!selectedPrefix || !tableNames || !tableNames[selectedPrefix]) return [];

        const query = searchQuery.toLowerCase().trim();
        const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

        return filteredTablesForPrefix.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPrefix]);

    const sortedRecords = useMemo(() => {
        return [...filteredRecords].sort((a, b) => {
            const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts;
        });
    }, [filteredRecords, searchQuery]);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords1 = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages1 = Math.ceil(sortedRecords.length / recordsPerPage);



    const handleSearchChange = (e) => {
        const input = e.target.value.trimStart(); // Remove leading spaces
        setSearchQuery(input);

        const pageNumber = parseInt(input, 10);

        // Check if input is a valid page number
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages1) {
            paginate1(pageNumber);
        }
    };

    useEffect(() => {
        if (!hasFetchedData.current || location.search) {
            fetchData1();
            hasFetchedData.current = true;
        }
    }, [location.search]);

    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    const fetchData1 = async (item) => {
        setIsLoading(true);
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const paramValue = urlParams.get('param');
            setSelectedTableName(item);
            setTableName(item);
            setvalidErrorRecords([]);

            if (!item) {
                setSelectedFileName(null); // or clear state as needed
                return;
            }

            const selectedName = item.split('_').slice(1).join('_');
            setSelectedFileName(selectedName);
            const fileName = `${department}_${item}`;
            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken
                },
                withCredentials: true,
                params: { "tableName": item, userRole: localStorage.getItem('userRole'), "type": "" }
                // params: { "tableName": tableNameParam, userRole:"Admin", "type": "" }
            };

            const apiresponse = await axios.post(demtableattributespreview, {}, config);

            if (apiresponse.data && apiresponse.data.fileName) {
                const fetchedFileName = apiresponse.data.fileName;
                // const response = await fetch(`${PortURL}/templates/${fetchedFileName}`);
                const response = await fetch(`/templates/${fetchedFileName}`);
                if (!response.ok) {
                    throw new Error('Nothing Pending for Preview');
                }

                const jsonData = await response.json();

                if (jsonData && jsonData.length > 0) {
                    const modifiedData = jsonData.map(row => {
                        if (['date', 'long'].includes(row['col_type']?.toLowerCase())) {
                            return { ...row, col_length: '' };
                        }
                        return row;
                    });

                    setTableData(modifiedData);
                    setTableColumns(Object.keys(modifiedData[0]));
                    setError(null);
                } else {
                    setError('Nothing Pending for Preview');
                }
            }
            else if (apiresponse.data && apiresponse.data.message) {
                const message = apiresponse.data.message;
                if (!apiresponse.ok) {


                    if (message === "Review is pending with this table, cannot modify it.") {
                        setModalMessageOne(`Review is pending with ${paramValue}, cannot modify it.`);
                        setShowModal(true);
                    }
                    else if (message === "This template is already modified and under review, can't modify now.") {
                        setModalMessageOne(`${paramValue} is already modified and under review, can't modify now.`);
                        setShowModal(true);
                    }
                    else if (message === "Retrieval data Review is pending with this table, cannot modify it.") {
                        setModalMessageOne(`Retrieval data Review is pending with this ${paramValue}, cannot modify it.`);
                        setShowModal(true);
                    } else {
                        setModalMessageOne(`${message}`);
                    }
                }

                else {
                    throw new Error('Nothing Pending for Preview');
                }
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };



    const pushRowToTop = (index) => {
        if (index === 0) return;
        const updatedData = [...tableData];
        const [movedRow] = updatedData.splice(index, 1);
        updatedData.unshift(movedRow);
        setTableData(updatedData);

        updateSelectionAfterMove(index, 0);
    };

    const updateSelectionAfterMove = (fromIndex, toIndex) => {
        const updatedSelected = [...selectedRows];
        if (updatedSelected.includes(fromIndex)) {
            updatedSelected.splice(updatedSelected.indexOf(fromIndex), 1, toIndex);
        }
        setSelectedRows(updatedSelected);
    };

    const moveRowUp = (index) => {
        if (index === 0) return;

        const updatedData = [...tableData];
        [updatedData[index - 1], updatedData[index]] = [updatedData[index], updatedData[index - 1]];
        setTableData(updatedData);
        // Update selectedRows to match new order
        const updatedSelectedRows = [...selectedRows];
        if (selectedRows.includes(index)) {
            updatedSelectedRows.splice(updatedSelectedRows.indexOf(index), 1, index - 1);
        } else if (selectedRows.includes(index - 1)) {
            updatedSelectedRows.splice(updatedSelectedRows.indexOf(index - 1), 1, index);
        }
        setSelectedRows(updatedSelectedRows);
    };

    const moveRowDown = (index) => {
        if (index === tableData.length - 1) return;

        const updatedData = [...tableData];
        [updatedData[index + 1], updatedData[index]] = [updatedData[index], updatedData[index + 1]];
        setTableData(updatedData);

        // Update selectedRows to match new order
        const updatedSelectedRows = [...selectedRows];
        if (selectedRows.includes(index)) {
            // Replace index with index + 1
            updatedSelectedRows.splice(updatedSelectedRows.indexOf(index), 1, index + 1);
        } else if (selectedRows.includes(index + 1)) {
            // Replace index + 1 with index
            updatedSelectedRows.splice(updatedSelectedRows.indexOf(index + 1), 1, index);
        }
        setSelectedRows(updatedSelectedRows);
    };


    const pushRowToBottom = (index) => {
        if (index === tableData.length - 1) return;
        const updatedData = [...tableData];
        const [movedRow] = updatedData.splice(index, 1);
        updatedData.push(movedRow);
        setTableData(updatedData);

        updateSelectionAfterMove(index, updatedData.length - 1);
    };


    const handleIncrementColLength = (rowIndex) => {
        const updatedTableData = tableData.map((row, index) => {
            if (index === rowIndex && row.col_length !== '') {
                const colType = row.col_type?.toLowerCase();

                // Handle decimal, float, double with precision, scale
                if (["decimal", "float", "double"].includes(colType)) {
                    let [precision, scale] = row.col_length.split(',').map(Number);

                    if (!row.originalColLength) {
                        row.originalColLength = `${precision},${scale}`;
                    }

                    // Increase scale first until 9, then increase precision
                    if (scale < 9) {
                        scale += 1;
                    } else {
                        precision += 1;
                        scale = 0;
                    }

                    return { ...row, col_length: `${precision},${scale}` };
                } else {
                    // Default behavior for other types
                    const currentColLength = parseInt(row.col_length);
                    const newColLength = currentColLength + 1;

                    if (!row.originalColLength) {
                        row.originalColLength = currentColLength;
                    }

                    return { ...row, col_length: newColLength.toString() };
                }
            }
            return row;
        });

        setTableData(updatedTableData);
    };

    const handleDecrementColLength = (rowIndex) => {
        const updatedTableData = tableData.map((row, index) => {
            if (index === rowIndex && row.col_length !== '') {
                const colType = row.col_type?.toLowerCase();

                // Handle decimal, float, double with precision, scale
                if (["decimal", "float", "double"].includes(colType)) {
                    let [precision, scale] = row.col_length.split(',').map(Number);
                    const [origPrecision, origScale] = row.originalColLength.split(',').map(Number);

                    const currTotal = precision * 10 + scale;
                    const origTotal = origPrecision * 10 + origScale;

                    if (currTotal > origTotal) {
                        if (scale > 0) {
                            scale -= 1;
                        } else if (precision > 0) {
                            precision -= 1;
                            scale = 9;
                        }

                        return { ...row, col_length: `${precision},${scale}` };
                    }
                } else {
                    // Default behavior for other types
                    const currentColLength = parseInt(row.col_length);
                    const originalColLength = parseInt(row.originalColLength);

                    if (currentColLength > originalColLength) {
                        const newColLength = currentColLength - 1;
                        return { ...row, col_length: newColLength.toString() };
                    }
                }
            }
            return row;
        });

        setTableData(updatedTableData);
    };

    const handleInputChange = (rowIndex, columnName, value) => {
        const updatedTableData = tableData.map((row, index) => {
            if (index === rowIndex) {
                const updatedRow = { ...row, [columnName]: value };

                if (columnName === 'col_type') {
                    const colType = value.toLowerCase();
                    updatedRow['isEditingColType'] = true;

                    // Set default col_length based on col_type
                    if (['date', 'long'].includes(colType)) {
                        updatedRow['col_length'] = '';
                    } else if (['double', 'float', 'decimal'].includes(colType)) {
                        updatedRow['col_length'] = '18,2';
                    } else if (colType === 'int') {
                        updatedRow['col_length'] = '8';
                    } else if (colType === 'varchar') {
                        updatedRow['col_length'] = '32';
                    } else if (colType === 'boolean') {
                        updatedRow['col_length'] = '1';
                    } else {
                        updatedRow['col_length'] = '';
                    }

                    // Mark row as being edited
                    setEditingColTypeRows((prev) => new Set(prev).add(rowIndex));
                }

                return updatedRow;
            }
            return row;
        });

        setTableData(updatedTableData);
    };

    // Validation function for data type only
    const isValidDataType = (colType) => {
        return allowedTypes.includes(colType.toLowerCase());
    };
    const handleBlur = (rowIndex, colType, header) => {
        // Validate `col_type` input
        if (header === 'col_type' && !isValidDataType(colType)) {
            const updatedTableData = [...tableData];
            updatedTableData[rowIndex][header] = ''; // Clear invalid value
            updatedTableData[rowIndex]['isEditingColType'] = false; // Stop editing on invalid input
            setTableData(updatedTableData);

            // Show modal with validation error
            setModalMessage(`Allowed datatypes: 'int', 'varchar', 'date', 'double', 'boolean', 'decimal'. Invalid data type: <strong>${toTitleCase(colType)}</strong>`);
            setShowModal(true);
        } else {
            // Stop editing state if valid
            const updatedTableData = tableData.map((row, index) => {
                if (index === rowIndex) {
                    return { ...row, isEditingColType: false };
                }
                return row;
            });

            setTableData(updatedTableData);
        }
    };

    const handleAddRow = () => {
        const newRow = tableColumns.reduce((acc, header) => ({ ...acc, [header]: '' }), {});
        newRow.isNewRow = true; // Flag to identify newly added rows
        setTableData([...tableData, newRow]);
        // setIsFullEdit(true);    
    };

    const handleDeleteRow = (rowIndex) => {
        const newTableData = tableData.filter((_, index) => index !== rowIndex);
        setTableData(newTableData);
    };

    const handleOperatorClick = (rowIndex) => {
        setActiveRowIndex(rowIndex); // Reuse same active row logic
        setIsOperatorModalOpen(true); // Open operator modal
    };

    // Get already selected column in the row
    // Get already selected column in the row
    // const getAvailableOperatorCols = () => {
    //     if (!tableData[activeRowIndex]) return [];
    //     return tableData.map(row => row.col_name).filter(Boolean);
    // };

    const getAvailableOperatorCols = (excludeCols = []) => {
        if (!tableData[activeRowIndex]) return [];

        return tableData
            .map(row => row.col_name)
            .filter(Boolean)
            .filter(col => !selectedColumns.includes(col)) // exclude selected checkboxes
            .filter(col => !excludeCols.includes(col));    // exclude additional columns
    };


    const handleFinalOperatorSelect = (secondCol) => {
        if (!firstCol || !selectedOperator) return;

        let expression = "";

        // Use the template to generate the correct expression format
        if (selectedOperator.template) {
            expression = selectedOperator.template(firstCol, secondCol);
        } else {
            // Fallback for operators without templates
            switch (selectedOperator.params) {
                case 0:
                    expression = `${selectedOperator.func}()`;
                    break;
                case 1:
                    expression = `${selectedOperator.func}(${firstCol})`;
                    break;
                case 2:
                    expression = `${selectedOperator.func}(${firstCol}, ${secondCol})`;
                    break;
                default:
                    expression = `${selectedOperator.func}(${firstCol}, ${secondCol})`;
            }
        }

        const updatedData = tableData.map((row, index) => {
            if (index === activeRowIndex) {
                return {
                    ...row,
                    col_functions: expression
                };
            }
            return row;
        });

        setTableData(updatedData);
        setIsOperatorModalOpen(false);
        setFirstCol(null);
        setSelectedOperator(null);
    };


    const getStepThreeTitle = () => {
        const { params, name } = selectedOperator;

        if (params === 0) return `Apply ${name} function`;
        if (params === 1) return `Apply ${name} to ${firstCol}`;
        if (params === 2) return `Choose second column for ${name}`;
        if (params === "special") {
            // Special cases with hardcoded parameters
            if (name === "DateFromMDY") return `DateFromMDY will use: Month=1, Day=1, Year=${firstCol}`;
            if (name === "DateFromYQ") return `DateFromYQ will use: Year=${firstCol}, Quarter=1`;
        }
        return `Configure ${name} parameters`;
    };

    const generateExpressionPreview = () => {
        const { template, params } = selectedOperator;

        if (template) {
            return template(firstCol, null);
        }

        switch (params) {
            case 0: return `${selectedOperator.func}()`;
            case 1: return `${selectedOperator.func}(${firstCol})`;
            case 2: return `${selectedOperator.func}(${firstCol}, ?)`;
            default: return `${selectedOperator.func}(${firstCol})`;
        }
    };

    const renderParameterSelection = () => {
        const { params, name } = selectedOperator;

        if (params === 0 || params === 1) {
            // For 0 or 1 parameter functions, apply directly
            return (
                <Button variant="btn btn-sm btn-outline-primary"
                    onClick={() => handleFinalOperatorSelect(null)}>
                    Apply {name} Function
                </Button>
            );
        }

        if (params === 2) {
            // For 2 parameter functions, show second column selection
            return (
                <ul className="list-group mt-2" style={{ height: "150px", overflowY: "auto" }}>
                    {getAvailableOperatorCols()
                        .filter(col => col !== firstCol && col !== activeColName)
                        .map((col, index) => (
                            <li key={index} className="list-group-item" style={{ cursor: "pointer" }}
                                onClick={() => handleFinalOperatorSelect(col)}>
                                {firstCol} {name} {col}
                            </li>
                        ))}
                </ul>
            );
        }

        if (params === "special") {
            // For special functions with hardcoded parameters
            return (
                <Button variant="btn btn-sm btn-outline-primary"
                    onClick={() => handleFinalOperatorSelect(null)}>
                    Apply {name} with fixed parameters
                </Button>
            );
        }

        return <p>Parameter selection needed for {name}</p>;
    };

    // const clearSelections = () => {
    //     setFirstCol(null);
    //     setSelectedOperator(null);
    // };

    // const generateExpressionPreview = () => {
    //     const { func, params } = selectedOperator;

    //     switch (params) {
    //         case 0: return `${func}()`;
    //         case 1: return `${func}(${firstCol})`;
    //         default: return `${func}(${firstCol})`;
    //     }
    // };
    const availableOperators = [
        // Arithmetic operators (need 2 columns in specific order)
        { name: "Addition", func: "Addition", params: 2, template: (col1, col2) => `Addition(${col1}, ${col2})` },
        { name: "Subtraction", func: "Subtraction", params: 2, template: (col1, col2) => `Subtraction(${col1}, ${col2})` },
        { name: "Multiplication", func: "Multiplication", params: 2, template: (col1, col2) => `Multiplication(${col1}, ${col2})` },
        { name: "Division", func: "Division", params: 2, template: (col1, col2) => `Division(${col1}, ${col2})` },
        { name: "Modulus", func: "mod", params: 2, template: (col1, col2) => `mod(${col1}, ${col2})` },

        // Date functions (no parameters)
        { name: "Now", func: "now", params: 0, template: () => `now()` },

        // Date extraction functions (single parameter)
        { name: "Year", func: "year", params: 1, template: (col1) => `year(${col1})` },
        { name: "Month", func: "month", params: 1, template: (col1) => `month(${col1})` },
        { name: "Quarter", func: "Quarter", params: 1, template: (col1) => `Quarter(${col1})` },
        { name: "Second", func: "second", params: 1, template: (col1) => `second(${col1})` },
        { name: "DayOfMonth", func: "DayOfMonth", params: 1, template: (col1) => `DayOfMonth(${col1})` },
        { name: "DayOfWeek", func: "DayOfWeek", params: 1, template: (col1) => `DayOfWeek(${col1})` },
        { name: "WeekNumber", func: "WeekNumber", params: 1, template: (col1) => `WeekNumber(${col1})` },
        { name: "DayOfYear", func: "DayOfYear", params: 1, template: (col1) => `DayOfYear(${col1})` },

        // Special date functions with mixed parameters
        {
            name: "DateFromMDY",
            func: "DateFromMDY",
            params: "special",
            template: (col1, col2) => `DateFromMDY(1, 1, ${col1})` // Month=1, Day=1, Year=selected column
        },
        {
            name: "DateFromYQ",
            func: "DateFromYQ",
            params: "special",
            template: (col1, col2) => `DateFromYQ(${col1}, 1)` // Year=selected column, Quarter=1
        }
    ];

    const handleRowSelection = (rowIndex) => {
        const newSelectedRows = [...selectedRows];
        let updatedTableData = [...tableData];

        if (newSelectedRows.includes(rowIndex)) {
            // Deselect the row
            newSelectedRows.splice(newSelectedRows.indexOf(rowIndex), 1);

            // Enable col_name, col_label, and col_type for the row
            updatedTableData = updatedTableData.map((row, index) => {
                if (index === rowIndex) {
                    return { ...row, disableFields: false }; // Reset disableFields flag
                }
                return row;
            });
        } else {
            // Select the row
            newSelectedRows.push(rowIndex);

            // Save the previous col_length for varchar or other specified types
            updatedTableData = updatedTableData.map((row, index) => {
                if (index === rowIndex &&
                    (row.col_type.toLowerCase() === 'varchar' ||
                        row.col_type.toLowerCase() === 'int' ||
                        row.col_type.toLowerCase() === 'float' ||
                        row.col_type.toLowerCase() === 'decimal' ||
                        row.col_type.toLowerCase() === 'bigint') // Add more column types as needed
                ) {
                    return { ...row, previousColLength: row.col_length, disableFields: true }; // Add disableFields flag
                }
                return row;
            });
        }

        setTableData(updatedTableData);
        setSelectedRows(newSelectedRows);
    };

    const handleTableNameChange = (e) => {
        const value = e.target.value;
        const validValue = /^[a-z0-9_]*$/; // Allow only lowercase, numbers, and underscores

        if (validValue.test(value)) {
            setEditableTableName(value);
            setInvalidTableNameMessage('');
        } else {
            setInvalidTableNameMessage(`Lowercase letters, Numbers, and Underscores are only Allowed,
Spaces(or) other Special characters are not allowed`);
        }
    };

    const handleSubmit = () => {
        const errorMessage = validateTableData();
        if (errorMessage) {
            setModalMessage(errorMessage);
            setShowModal(true);
            return;
        }

        submitWithNotification();
    };


    const handleEditToggle = () => {
        setShowConfirmationModal(true);

    };

    const handleConfirmYes = () => {
        setIsFullEditMode(true);
        setIsTableNameEditable(true);
        setShowConfirmationModal(false);
        setIsTableNameSet(true);
        setIsEditMode(true);
        setIsFullEdit(false);
        setIsNoEdit(false);
    };

    const handleConfirmNo = async () => {
        try {
            const urlParams = new URLSearchParams(location.search); // Use location.search to get query params
            const tableNameParam = urlParams.get('fileName');

            const config = {
                params: { "tableName": selectedFullTableName, "modify": "N" },
                headers: {
                    "userId": localStorage.getItem('userid'),
                    "x-csrf-token": csrfToken
                },
                withCredentials: true
                // params: { "tableName": tableNameParam, userRole:"Admin", "type": "" }
            };

            const apiresponse = await axios.post(allowmodifytemplate, {}, config);
            if (apiresponse.data && apiresponse.data.proceed == 'Yes') {
                setIsFullEditMode(true);
                setIsFullEdit(true);
                setIsNoEdit(false);
                setIsTableNameEditable(false);
                setShowConfirmationModal(false);
                setIsEditMode(true);
                setModifyAllow('');
            }
            else if (apiresponse.data && apiresponse.data.proceed == 'No') {
                const newModifyAllow = 'Y';
                setModifyAllow(newModifyAllow);
                // setModalMessage(apiresponse.data.message);
                setModalMessage(`<strong>${toTitleCase(selectedName)}</strong> Template is not allowed for <strong>Modification</strong>, records are Pending with Checker Review`)
                setMessageType('error');
                setShowConfirmationModal(false);
                setIsTableNameEditable(false);
                setIsFullEditMode(false);
                setIsFullEdit(false);
                // setModifyAllow('Y');
            }
        } catch {
            console.log("error occured");
        }
    };


    const submitWithNotification = async () => {
        // Close the modal after selection
        setShowNotifyModal(false);
        setLoading(true);


        // Determine the correct file name (new name if editableTableName is present, otherwise old tableName)
        const fileNameNoExt = editableTableName && editableTableName.trim() !== '' ? editableTableName : selectedName;

        if (!fileNameNoExt || fileNameNoExt.trim() === "") {
            setInvalidTableNameMessage('Please enter the table name.');
            return;
        }

        // Generate the content for the .txt file
        const txtContent = tableData
            .map(row =>
                tableColumns.map(header => row[header] || '').join('|')
            )
            .join('\n');

        // Create the .txt file with the correct name
        const blob = new Blob([txtContent], { type: 'text/plain' });
        const txtFile = new File([blob], fileNameNoExt + '.txt', { type: 'text/plain' });

        const formData = new FormData();
        formData.append('file', txtFile);
        formData.append('tableName', fileNameNoExt);
        formData.append('notifyOption', notifyOption);

        try {
            const uploadResponse = await axios.post(upload3001, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "x-csrf-token": csrfToken,
                    "userId": localStorage.getItem('userid')
                },
                withCredentials: true
            });

            if (uploadResponse.status === 200) {
                const filePath = "/saswork/nas/";

                await callAdditionalApi(fileNameNoExt, editableTableName, filePath, notifyOption, modifyAllow);
            }
        } catch (error) {
            console.error('File upload failed:', error.message);
            setInvalidTableNameMessage('File upload failed. Please try again.');
            setModalMessage(true);
        }
        finally {
            setLoading(false);
        }
    };


    const callAdditionalApi = async (tableName, editableTableName, filePath, notifyOption, modifyAllow) => {

        setLoading(true);
        const tableNameToSend = editableTableName && editableTableName.trim() !== '' ? editableTableName : selectedName;
        setIsLoading(true);
        try {
            let config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: {
                    "tableName": selectedName,
                    // "newTableName": editableTableName,
                    "newTableName": editableTableName && editableTableName.trim() !== '' ? editableTableName : "", // Only pass if present
                    "Notifications": "IN",
                    "filePath": `${filePath}${tableNameToSend}.txt`,
                    "modifyTemplate": modifyAllow,
                    "dept": Prefix
                }
            };
            console.log("Prefix Value", Prefix);
            const response = await axios.post(Modifytemplate, {}, config);

            // Store active_status and template_type in localStorage
            if (response.data?.active_status && response.data?.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);

            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }

            if (response.data && response.data.status === 'success') {
                // setModalMessage(response.data.message);
                setModalMessage(`<strong>${toTitleCase(tableNameToSend)}</strong> Template Modified Successfully`)
                setShowNotifyModal(false);
                setMessageType('success');
                setShowModal(true);
            } else {
                setModalMessage(response.data.message);
                setShowModal(true);
            }

            setShowNotifyModal(false);
        } catch (error) {
            setShowNotifyModal(false);
            console.error('Error in additional API call:', error.response ? error.response.data : error.message);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleModalClose = () => {
        if (messageType === 'success') {
            setModalMessage('');
            setShowModal(false);
            setShowModal('');
            setSelectedRows([]);
            setIsEditMode(false);
            setSelectedTableName(null); // clear then reassign
            setInvalidTableNameMessage('');
            setIsTableVisible(true);
            setIsTableNameVisible(true);
            setIsTableNameEditable(false);
            setEditableTableName('');
            setShowDeletePopup(false);
            // setPrefix('');
            setTableName('');
            setTableData([]);
            setTableColumns([]);
            setSelectedName('');
        }

        else {
            setModalMessage('');
            setModalMessage(false);
            setShowModal('');
            setShowModal(false);
        }
    };

    const validateTableData = () => {
        const allowedTypes = ["int", "varchar", "date", "double", "boolean", "decimal", "float", "char"];

        if (isTableNameEditable) {
            if (!editableTableName || editableTableName.trim() === "") {
                return "Table Name must not be Blank";
            }
        }

        const invalidColTypeRow = tableData.find((row) =>
            row.col_type && !allowedTypes.includes(row.col_type.toLowerCase())
        );

        if (invalidColTypeRow) {
            return `Allowed datatypes: 'int', 'varchar', 'date', 'double','boolean', 'decimal', 'float', 'char'. Invalid data type: ${invalidColTypeRow.col_type}`;
        }

        const invalidRow = tableData.find((row) => !row.col_name || !row.col_type);

        const invalidColLengthRow = tableData.find((row) =>
            row.col_type &&
            ["varchar", "int"].includes(row.col_type.toLowerCase()) &&
            (!row.col_length || row.col_length === '' || isNaN(row.col_length))
        );


        const invalidColNameRow = tableData.find((row) => {
            const colName = String(row.col_name || "");
            const isValid = /^[A-Za-z0-9_]+$/.test(colName);
            return !isValid;
        });

        const rename = tableData.find((row) =>
            row.col_rename &&
            row.col_name &&
            row.col_rename.trim().toLowerCase() === row.col_name.trim().toLowerCase()
        );

        const duplicateColumn = tableData.reduce((acc, row) => {
            const name = row.col_name?.trim().toLowerCase();
            if (name) {
                acc[name] = (acc[name] || 0) + 1;
            }
            return acc;
        }, {});

        const duplicate = Object.entries(duplicateColumn).find(([_, count]) => count > 1);

        const commaSeparatedNumberRegex = /^\d+(\.\d+)?(,\d+(\.\d+)?)*$/;

        const invalidCommaSeparatedRow = tableData.find((row) =>
            row.col_type &&
            ["double", "decimal", "float"].includes(row.col_type.toLowerCase()) &&
            row.col_value &&
            !commaSeparatedNumberRegex.test(row.col_value.trim())
        );

        const invalidDoubleColLengthRow = tableData.find((row) =>
            row.col_type &&
            ["double", "float", "decimal"].includes(row.col_type.toLowerCase()) &&
            (!row.col_length || row.col_length.trim() === "" || !/^\d+(\.\d+)?(,\d+(\.\d+)?)+$/.test(row.col_length.trim()))
        );

        if (duplicate) {
            return `COLUMN_NAME <strong>${toTitleCase(duplicate[0])}</strong> is already available. Please choose a different name`;
        } else if (invalidRow) {
            return "Required field(s) must not be Blank";
        } else if (invalidColLengthRow) {
            return "COLUMN_LENGTH is required, and must be a valid Number for the selected COLUMN_TYPE";
        } else if (rename) {
            return "<strong>COLUMN_RENAME/strong> field cannot have the same name as <strong>COLUMN_NAME</strong>. Please provide a different name";
        } else if (invalidCommaSeparatedRow) {
            return `COLUMN_LENGTH must be in <strong>precision,scale</strong> (eg: 18,2) for COLUMN_TYPE Double, Float and Decimal`;
        } else if (invalidDoubleColLengthRow) {
            return "COLUMN_LENGTH must not be <strong>Blank</strong> for COLUMN_TYPE Double, Float and Decimal";
        }
        else if (invalidColNameRow) {
            return `Invalid (or) Incorrect COLUMN_NAME <strong>${toTitleCase(invalidColNameRow.col_name)}</strong>. Letters (A-Z, a-z), Numbers (0-9), and Underscores (_) are only allowed`;
        }
        return null; // No validation errors
    };


    const handleReset = () => {
        setSelectedRows([]);
        setIsEditMode(false);
        setSelectedTableName(null); // clear then reassign
        setInvalidTableNameMessage('');
        setIsTableVisible(true);
        setIsTableNameVisible(true);
        setEditableTableName('');
        setIsTableNameEditable(false);
        setShowDeletePopup(false);
        setPrefix('');
        setTableName('');
        setTableData([]);
        // setHeaders([]);

        // Delay is optional if you want a "soft reset"
        setTimeout(() => {
            fetchData1(selectedTableName); // or `tableName`, depending on your state
        }, 100);
    };

    const handleUpdate = () => {
        setIsSubmitEnabled(true);

        const errorMessage = validateTableData();

        if (errorMessage) {
            setShouldResetOnGoBack(false);
            setMessageType('danger');
            setModalMessage(errorMessage);
            setShowModal(true);
            return;
        }

        setIsEditMode(false);
        setSelectedRows([]);
        setShouldResetOnGoBack(true);
    };


    const filteredTableData = tableData.filter(item =>
        Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const totalRecords = filteredTableData.length;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const currentRecords = filteredTableData.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);


    useEffect(() => {
        if (searchTerm && filteredTableData.length === 0) {
            setShowNoRecordsModal(true);
            setSearchTerm('');
            setCurrentPage(1);
        }
    }, [searchTerm, filteredTableData]);

    const fetchDropdownData = async () => {
        const adminId = localStorage.getItem('userid');
        const config = {
            headers: { "adminId": adminId, "x-csrf-token": csrfToken },
            withCredentials: true
        };

        try {
            const response = await axios.post(dropdownlist, {}, config);
            const masterTableInfo = response.data?.master_table_info || [];
            const colNames = masterTableInfo.map(item => item.col_name);

            setColNames(prev => {
                // Only update if the new colNames are different
                return JSON.stringify(prev) !== JSON.stringify(colNames) ? colNames : prev;
            });
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    const [firstCol, setFirstCol] = useState(null);
    const [selectedColumns, setSelectedColumns] = useState([]); // array of col_name


    const handleDropdownClick = (rowIndex) => {
        setActiveRowIndex(rowIndex);
        setIsModalOpen(true);
        fetchDropdownData();
    };


    const handleOptionSelect = (selectedCol) => {

        const updatedData = tableData.map((row, index) => {
            if (index === activeRowIndex) {
                return {
                    ...row,
                    col_functions: selectedCol ? `dropdown(${selectedCol})` : "" // Clear if empty
                };
            }
            return row;
        });

        setTableData(updatedData); // Update the table data state
    };

    const handleOkClick = () => {
        if (selectedColName !== null) {
            handleOptionSelect(selectedColName); // This will pass empty string too
            setSearchText("");         // Reset search
            setSelectedColName("");    // Reset selection
            setIsModalOpen(false);     // Close modal
        }
    };


    const handleOkClick1 = () => {
        if (selectedColName !== null) {
            handleOptionSelect(selectedColName); // This will pass empty string too
            setSearchText("");         // Reset search
            setSelectedColName("");    // Reset selection
            setSelectedOperator(null); // Reset selected operator
            setIsOperatorModalOpen(false);     // Close modal
        }
    };

    const clearSelections = () => {
        setFirstCol(null);          // Reset first column
        setSelectedOperator(null);
    };

    const filteredColNames = colNames.filter((colName) =>
        colName.toLowerCase().includes(searchText.toLowerCase())
    ); // Filter based on search input
    const activeColName = tableData[activeRowIndex]?.col_name;


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a className={`text-info ${styles.textInfo}`} onClick={handleDashboard} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi-pencil me-2"></i>1.4 Modify Existing Template
                                </li>

                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            {/* Right Column with Buttons */}
                            <div className="col-lg-4 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body p-2">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <div>
                                                <DepartmentDropdown
                                                    selectedPrefix={selectedPrefix}
                                                    setSelectedPrefix={setSelectedPrefix}
                                                    prefixes={prefixes}
                                                />
                                            </div>
                                            {/* Search Bar */}
                                            <div className="flex-grow-1">
                                                <Listoftablesearchbox1
                                                    searchQuery={searchQuery}
                                                    onSearchChange={handleSearchChange}
                                                />
                                            </div>
                                        </div>

                                        <TableTemplateListGapsy
                                            currentRecords={currentRecords1}
                                            ListofTableFontsize={ListofTableFontsize}
                                            handleTableClick={handleTableClick}
                                            currentPage={currentPage}  // Pass currentPage
                                            recordsPerPage={recordsPerPage}  // Pass recordsPerPage
                                        />
                                        {/* </div> */}

                                        {/* </div> */}
                                        {sortedRecords.length > recordsPerPage && (
                                            <PaginationComponentForm2
                                                currentPage={currentPage}
                                                totalPages={totalPages1}
                                                paginate={paginate1}
                                                recordsPerPage={recordsPerPage}
                                                tableNames={sortedRecords} // ← pass sorted list
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Left Column with Table */}
                            <div className="col-lg-8 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="mb-1">
                                            {/* <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify Existing Template : {selectedName}</h6> */}
                                            <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>
                                                Modify Existing Template :{" "}
                                                {selectedName
                                                    .replace(/_/g, ' ') // Replace underscores with spaces
                                                    .split(' ') // Split into words
                                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                                                    .join(' ')} {/* Join back with spaces */}
                                            </h6>

                                            {isTableNameEditable && (
                                                <div
                                                    className="form-group d-flex align-items-center mt-2 mb-2" // <-- Added mb-3 here
                                                >  <label htmlFor="tableName" className="mr-2" style={{ color: 'black', fontSize: '14px' }}>
                                                        Table Name:
                                                    </label>
                                                    <div className="input-container d-flex align-items-center">
                                                        <input
                                                            type="text"
                                                            id="tableName"
                                                            className={`form-control form-control-sm ${invalidTableNameMessage ? 'is-invalid' : ''}`}
                                                            style={{
                                                                width: '180px',
                                                                fontSize: '13px',
                                                                padding: '4px 8px',
                                                                borderRadius: '4px'
                                                            }}
                                                            value={editableTableName}
                                                            onChange={handleTableNameChange}
                                                        />
                                                        {invalidTableNameMessage && (
                                                            <div
                                                                className="invalid-feedback d-block"
                                                                style={{ color: 'black', fontSize: '12px', marginLeft: '10px' }}
                                                            >
                                                                {invalidTableNameMessage}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <div className="row">
                                                <div className="col">
                                                    <div className="table-on-homepage-only">
                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                            {isTableVisible && (
                                                                <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                                                    <thead className="sticky-header">
                                                                        <tr>
                                                                            {isEditMode && (
                                                                                <th></th>
                                                                            )}
                                                                            {tableColumns
                                                                                // .filter(header => !(isFullEditMode && (header === 'col_active' || header === 'col_rename')))
                                                                                .filter(header => !(isFullEditMode && !isFullEdit && isNoEdit && (header === 'col_active' || header === 'col_rename')))
                                                                                // .filter(header => !(isFullEditMode && !isNoEdit && (header === 'col_active' || header === 'col_rename')))
                                                                                .map((header, index) => (
                                                                                    <th key={index} style={{ fontSize: '12px', textAlign: 'center' }}>
                                                                                        {TableHeader.aliasNames[header] || header}
                                                                                    </th>
                                                                                ))}
                                                                            {isEditMode && (
                                                                                <th style={{ textAlign: 'center', fontSize: '12px' }}>ACTIONS</th>
                                                                            )}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {tableData.map((row, rowIndex) => (
                                                                            <tr key={rowIndex}>
                                                                                {isEditMode && (
                                                                                    <td style={{ textAlign: 'left' }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            disabled={!isFullEditMode && row.col_key === 'PRIMARY KEY'}
                                                                                            checked={selectedRows.includes(rowIndex)}
                                                                                            onChange={(e) => {
                                                                                                e.stopPropagation();
                                                                                                handleRowSelection(rowIndex);
                                                                                            }}
                                                                                            style={{
                                                                                                width: '16px',
                                                                                                height: '16px',
                                                                                                borderRadius: '50%',
                                                                                                border: '1px solid #6c757d',
                                                                                                backgroundColor: 'transparent',
                                                                                                boxShadow: selectedRows.includes(rowIndex)
                                                                                                    ? 'inset 0 0 0 5px #6c757d'
                                                                                                    : 'none',
                                                                                                cursor: 'pointer',
                                                                                            }}
                                                                                        />

                                                                                        {(isFullEditMode || row.isNewRow) && ( // Show delete icon only for "Add Row" rows
                                                                                            <button
                                                                                                type="button"
                                                                                                // onClick={() => handleDeleteRow(rowIndex)} 
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation(); // Prevent checkbox selection from changing
                                                                                                    handleDeleteRow(rowIndex);
                                                                                                }}
                                                                                                style={{
                                                                                                    background: 'none',
                                                                                                    border: 'none',
                                                                                                    padding: '0 5px',
                                                                                                    cursor: 'pointer',
                                                                                                    marginLeft: '5px',
                                                                                                }}
                                                                                            >
                                                                                                <BsTrash /> {/* Delete icon */}
                                                                                            </button>
                                                                                        )}
                                                                                    </td>
                                                                                )}

                                                                                {tableColumns
                                                                                    .filter(header => !(isFullEditMode && !isFullEdit && isNoEdit && (header === 'col_active' || header === 'col_rename')))
                                                                                    .map((header, colIndex) => (
                                                                                        <td key={colIndex} style={tableCellStyle3(rowIndex)}>
                                                                                            {isEditMode && selectedRows.includes(rowIndex) ? (
                                                                                                header === 'col_active' ? (
                                                                                                    // Render a dropdown for "col_active"
                                                                                                    <select
                                                                                                        value={row[header] || 'Yes'} // Default value is "Yes"
                                                                                                        onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                        className="form-select"
                                                                                                        style={{
                                                                                                            minWidth: '100px',
                                                                                                            fontSize: '12px',
                                                                                                            fontWeight: '200',
                                                                                                        }}
                                                                                                    >
                                                                                                        <option value="Y">Yes</option>
                                                                                                        <option value="N">No</option>
                                                                                                    </select>
                                                                                                ) : header === 'col_name' || header === 'col_key' || header === 'col_type' ? (
                                                                                                    header === 'col_type' ? (
                                                                                                        // col_type dropdown
                                                                                                        <select
                                                                                                            disabled={(isNoEdit && !row.isNewRow) || (!isFullEditMode && row.disableFields)}
                                                                                                            className="form-control"
                                                                                                            value={row[header] || ""}
                                                                                                            onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                            onBlur={() => {
                                                                                                                handleBlur(rowIndex, row["col_type"], header);
                                                                                                                setActiveEditCell({ rowIndex: null, columnName: null });
                                                                                                            }}
                                                                                                            style={{
                                                                                                                minWidth: "100px",
                                                                                                                fontSize: "12px",
                                                                                                                fontWeight: "200",
                                                                                                                width: "auto",
                                                                                                                backgroundColor: !isFullEditMode && row.disableFields ? '#f8f9fa' : 'white',
                                                                                                            }}
                                                                                                        >
                                                                                                            <option value="">Select Type</option>
                                                                                                            {["INT", "VARCHAR", "DATE", "DOUBLE", "BOOLEAN", "DECIMAL", "FLOAT", "CHAR"].map((type) => (
                                                                                                                <option key={type} value={type}>
                                                                                                                    {type}
                                                                                                                </option>
                                                                                                            ))}
                                                                                                        </select>
                                                                                                    ) : header === 'col_key' ? (
                                                                                                        // col_key dropdown
                                                                                                        <select
                                                                                                            disabled={(isNoEdit && !row.isNewRow) || (!isFullEditMode && row.disableFields)}
                                                                                                            className="form-control"
                                                                                                            value={row[header] || ""}
                                                                                                            onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                            onBlur={() => setActiveEditCell({ rowIndex: null, columnName: null })}
                                                                                                            style={{
                                                                                                                minWidth: "100px",
                                                                                                                fontSize: "12px",
                                                                                                                fontWeight: "200",
                                                                                                                width: "auto",
                                                                                                                backgroundColor: !isFullEditMode && row.disableFields ? '#f8f9fa' : 'white',
                                                                                                            }}
                                                                                                        >
                                                                                                            <option value="">Select Key</option>
                                                                                                            <option value="null">NULL</option>
                                                                                                            <option value="not null">NOT NULL</option>
                                                                                                            <option value="primary key">PRIMARY KEY</option>
                                                                                                        </select>
                                                                                                    ) : (
                                                                                                        // col_name or fallback input
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            value={row[header] || ''}
                                                                                                            disabled={(isNoEdit && !row.isNewRow) || (!isFullEditMode && row.disableFields)}
                                                                                                            onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                            className="form-control"
                                                                                                            style={{
                                                                                                                minWidth: '100px',
                                                                                                                fontSize: '12px',
                                                                                                                fontWeight: '200',
                                                                                                                backgroundColor: !isFullEditMode && row.disableFields ? '#f8f9fa' : 'white',
                                                                                                            }}
                                                                                                        />
                                                                                                    )

                                                                                                ) : header === 'col_functions' ? (
                                                                                                    <div className="d-flex align-items-center">
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            value={row[header] || ''}
                                                                                                            onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                            onBlur={() => handleBlur(rowIndex, row['col_type'], header)} // Validate onBlur
                                                                                                            className="form-control"
                                                                                                            style={{
                                                                                                                minWidth: '100px',
                                                                                                                fontSize: '12px',
                                                                                                                fontWeight: '200',
                                                                                                                width: `${Math.max((row[header.toLowerCase()] || '').length + 1, 15)}ch`,
                                                                                                            }}
                                                                                                            disabled // Disable text input for col_functions
                                                                                                        />
                                                                                                        <button
                                                                                                            className="btn btn-sm btn-outline-secondary rounded-circle"
                                                                                                            onClick={() => handleDropdownClick(rowIndex)}
                                                                                                            style={{ padding: 0, marginLeft: '10px', height: '20px', width: '20px', lineHeight: 'normal' }}
                                                                                                        >
                                                                                                            <FaPlus size={12} />
                                                                                                        </button>
                                                                                                        <button
                                                                                                            className="btn btn-sm btn-outline-secondary rounded-circle ms-2"
                                                                                                            onClick={() => handleOperatorClick(rowIndex)}
                                                                                                            style={{
                                                                                                                padding: '2px',
                                                                                                                width: '20px',
                                                                                                                height: '20px',
                                                                                                                display: 'flex',
                                                                                                                alignItems: 'center',
                                                                                                                justifyContent: 'center'
                                                                                                            }}
                                                                                                        >
                                                                                                            <FaEquals size={10} /> {/* use any operator icon e.g., from react-icons */}
                                                                                                        </button>
                                                                                                    </div>
                                                                                                ) : header === 'col_length' ? (
                                                                                                    ['date', 'long',].includes(row.col_type?.toLowerCase()) ? (
                                                                                                        <span>{row[header] || ''}</span>
                                                                                                    ) : isFullEditMode ? (
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            value={row[header] || ''}
                                                                                                            disabled={!isFullEditMode} // Disable if full edit mode is off
                                                                                                            onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                            onBlur={() => handleBlur(rowIndex, row['col_type'], header)} // Trigger handleBlur on blur
                                                                                                            className="form-control"
                                                                                                            style={{
                                                                                                                minWidth: '100px',
                                                                                                                fontSize: '12px',
                                                                                                                fontWeight: '200',
                                                                                                                backgroundColor: isFullEditMode ? 'white' : '#f8f9fa', // Gray out when disabled
                                                                                                                width: `${Math.max((row[header] || '').length + 1, 5)}ch`,
                                                                                                            }}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        // If not in full edit mode, follow existing conditions with increment/decrement buttons
                                                                                                        editingColTypeRows.has(rowIndex) ? (
                                                                                                            <input
                                                                                                                type="text"
                                                                                                                value={row[header] || ''}
                                                                                                                onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                                onBlur={() => handleBlur(rowIndex, row['col_type'], header)} // Trigger handleBlur on blur
                                                                                                                className="form-control"
                                                                                                                style={{
                                                                                                                    minWidth: '100px',
                                                                                                                    fontSize: '12px',
                                                                                                                    fontWeight: '200',
                                                                                                                    width: `${Math.max((row[header] || '').length + 1, 5)}ch`,
                                                                                                                }}
                                                                                                            />
                                                                                                        ) : (
                                                                                                            // Render increment and decrement buttons by default
                                                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                                                                <span style={{ flex: 1 }}>{row[header] || ''}</span>
                                                                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                                                                    {/* Increment Button (Always shown initially) */}
                                                                                                                    <button
                                                                                                                        type="button"
                                                                                                                        onClick={() => handleIncrementColLength(rowIndex)}
                                                                                                                        style={{
                                                                                                                            marginLeft: '5px',
                                                                                                                            padding: '0 5px',
                                                                                                                            cursor: 'pointer',
                                                                                                                            background: 'none',
                                                                                                                            border: '1px solid #ccc',
                                                                                                                            fontSize: '12px',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <AiFillCaretUp />
                                                                                                                    </button>

                                                                                                                    {/* {row.originalColLength && parseInt(row[header]) > row.originalColLength && ( */}
                                                                                                                    {row.originalColLength && (() => {
                                                                                                                        const colType = row.col_type?.toLowerCase();

                                                                                                                        if (["decimal", "float", "double"].includes(colType)) {
                                                                                                                            const [currP, currS] = row.col_length.split(',').map(Number);
                                                                                                                            const [origP, origS] = row.originalColLength.split(',').map(Number);

                                                                                                                            const currTotal = currP * 10 + currS;
                                                                                                                            const origTotal = origP * 10 + origS;

                                                                                                                            return currTotal > origTotal;
                                                                                                                        } else {
                                                                                                                            return parseInt(row.col_length) > parseInt(row.originalColLength);
                                                                                                                        }
                                                                                                                    })() && (
                                                                                                                            <button
                                                                                                                                type="button"
                                                                                                                                onClick={() => handleDecrementColLength(rowIndex)}
                                                                                                                                style={{
                                                                                                                                    marginLeft: '5px',
                                                                                                                                    padding: '0 5px',
                                                                                                                                    cursor: 'pointer',
                                                                                                                                    background: 'none',
                                                                                                                                    border: '1px solid #ccc',
                                                                                                                                    fontSize: '12px',
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                <AiFillCaretDown />
                                                                                                                            </button>
                                                                                                                        )}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )
                                                                                                    )

                                                                                                ) : (
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        value={row[header] || ''}
                                                                                                        onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                                                                        className="form-control"
                                                                                                        style={{
                                                                                                            minWidth: '100px',
                                                                                                            fontSize: '12px',
                                                                                                            fontWeight: '200',
                                                                                                            width: `${Math.max((row[header] || '').length + 1, 15)}ch`,
                                                                                                        }}
                                                                                                    />
                                                                                                )
                                                                                            ) : (
                                                                                                header === 'col_label'
                                                                                                    ? toCamelCaseforTableProps(row[header] || '') // Call the function
                                                                                                    : ['col_key', 'col_type', 'col_name'].includes(header)
                                                                                                        ? (row[header] || '').toLowerCase() // Convert to lowercase
                                                                                                        // Render table data for non-edit mode
                                                                                                        : row[header] === null || row[header] === 'null' || row[header] === 'NULL' ? '' : row[header]
                                                                                            )}
                                                                                        </td>

                                                                                    ))}
                                                                                {isEditMode && (
                                                                                    <td style={tableCellStyle4(rowIndex)}>

                                                                                        {/* Push Top */}


                                                                                        {/* Move Up */}
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => moveRowUp(rowIndex)}
                                                                                            disabled={rowIndex === 0}
                                                                                            className="btn btn-sm btn"
                                                                                            style={{ border: 'none' }}
                                                                                            title="Move Up"
                                                                                        >
                                                                                            <FaArrowUp size={12} />
                                                                                        </button>

                                                                                        {/* Move Down */}
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => moveRowDown(rowIndex)}
                                                                                            disabled={rowIndex === tableData.length - 1}
                                                                                            className="btn btn-sm btn"
                                                                                            style={{ border: 'none' }}
                                                                                            title="Move Down"
                                                                                        >
                                                                                            <FaArrowDown size={12} />
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => pushRowToTop(rowIndex)}
                                                                                            disabled={rowIndex === 0}
                                                                                            className="btn btn-sm btn"
                                                                                            style={{ border: 'none' }}
                                                                                            title="Push to Top"
                                                                                        >
                                                                                            <FaAngleDoubleUp size={12} />
                                                                                        </button>

                                                                                        {/* Push Bottom */}
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => pushRowToBottom(rowIndex)}
                                                                                            disabled={rowIndex === tableData.length - 1}
                                                                                            className="btn btn-sm btn"
                                                                                            style={{ border: 'none' }}
                                                                                            title="Push to Bottom"
                                                                                        >
                                                                                            <FaAngleDoubleDown size={12} />
                                                                                        </button>

                                                                                    </td>
                                                                                )}


                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>


                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Buttons below table aligned left */}
                                            {!isEditMode && selectedTableName && (
                                                <div className="row my-1">
                                                    <div className="col text-end">
                                                        <button className="btn btn-sm btn-outline-primary me-2" onClick={handleEditToggle}>Edit</button>
                                                        <button className="btn btn-sm btn-primary" onClick={handleSubmit}
                                                            disabled={!isSubmitEnabled}>Submit</button>
                                                    </div>
                                                </div>
                                            )}
                                            {isEditMode && (
                                                <div className="row my-1">
                                                    <div className="col text-end">
                                                        <button
                                                            className="btn btn-sm btn-outline-primary me-2"
                                                            onClick={handleAddRow}
                                                            title="Add Row"
                                                        >
                                                            <i className="bi bi-plus" style={{ fontSize: '20px' }}></i>
                                                        </button>

                                                        <button
                                                            className="btn btn-sm btn-outline-success me-2"
                                                            onClick={handleUpdate}
                                                            title="Update"
                                                        >
                                                            <i className="bi bi-upload" style={{ fontSize: '20px' }}></i>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-dark"
                                                            onClick={handleReset}
                                                            title="Reset"
                                                        >
                                                            <i className="bi bi-x-circle" style={{ fontSize: '20px' }}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {loading && (
                                        <div className="loading-overlay">
                                            <UploadLoadingIcon />
                                        </div>
                                    )}
                                    <Modal
                                        show={isModalOpen}
                                        onHide={() => setIsModalOpen(false)}
                                        centered
                                        style={{ marginTop: "0vh" }}
                                    >

                                        <Modal.Header
                                            style={{
                                                backgroundColor: '#366872',
                                                color: 'white',
                                                padding: '0.5rem 1rem'
                                            }}
                                        >
                                            <Modal.Title style={{ fontSize: '16px' }}>
                                                Select a function
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body style={{ fontSize: '14px' }}>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control form-control sm"
                                                    placeholder="Type to search..."
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                />
                                                <ul
                                                    className="list-group mt-2"
                                                    style={{
                                                        height: "150px",
                                                        overflowY: "auto",
                                                        border: "1px solid #ced4da", // Border for the list container
                                                        borderRadius: "0.25rem",
                                                        padding: "0", // Remove padding to avoid extra spacing
                                                        margin: "0", // Remove margin to avoid extra space around the list
                                                    }}
                                                >
                                                    <li
                                                        className={`list-group-item ${selectedColName === "" ? "active" : ""}`}
                                                        onClick={() => setSelectedColName("")}
                                                        style={{
                                                            cursor: "pointer",
                                                            backgroundColor: selectedColName === "" ? "#e9ecef" : "transparent",
                                                            color: selectedColName === "" ? "#495057" : "#212529",
                                                            border: "none",
                                                            padding: "2px 5px",

                                                        }}
                                                    >
                                                        Clear selection
                                                    </li>

                                                    {filteredColNames.length > 0 ? (
                                                        filteredColNames.map((colName, index) => (
                                                            <li
                                                                key={index}
                                                                className={`list-group-item ${colName === selectedColName ? "active" : ""}`}
                                                                onClick={() => setSelectedColName(colName)}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    backgroundColor: selectedColName === colName ? "#e9ecef" : "transparent", // Highlight selected column
                                                                    color: selectedColName === colName ? "#495057" : "#212529", // Change text color for selected column
                                                                    border: "none", // Remove borders between list items
                                                                    padding: "2px 5px", // Minimal padding for list items
                                                                }}
                                                            >
                                                                {colName}
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <li className="list-group-item text-muted" style={{ border: "none" }}>No matching columns</li>
                                                    )}
                                                </ul>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer
                                            style={{ borderTop: 'none' }}>
                                            <Button variant="btn btn-sm btn-outline-secondary"

                                                onClick={() => setIsModalOpen(false)}>
                                                Close
                                            </Button>
                                            <Button

                                                variant="btn btn-sm btn-outline-primary" onClick={handleOkClick}>
                                                OK
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>

                                    <Modal show={isOperatorModalOpen} onHide={() => setIsOperatorModalOpen(false)} centered>
                                        <Modal.Header style={{ backgroundColor: '#6c757d', color: 'white', padding: '0.5rem 1rem' }}>
                                            <Modal.Title style={{ fontSize: '16px' }}>Select Operator</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body style={{ fontSize: '14px' }}>
                                            <div className="form-group">
                                                {!firstCol && (
                                                    <>
                                                        <p><strong>Step 1: Choose first column</strong></p>
                                                        <ul className="list-group mt-2" style={{ height: "150px", overflowY: "auto" }}>
                                                            {getAvailableOperatorCols([activeColName]).map((col, index) => (
                                                                <li key={index} className="list-group-item" style={{ cursor: "pointer" }}
                                                                    onClick={() => setFirstCol(col)}>
                                                                    {col}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </>
                                                )}

                                                {firstCol && !selectedOperator && (
                                                    <>
                                                        <p><strong>Step 2: Choose operator for {firstCol}</strong></p>
                                                        {availableOperators.map((op, i) => (
                                                            <Button key={i} size="sm" variant="outline-primary" className="me-2 mb-2"
                                                                onClick={() => setSelectedOperator(op)}>
                                                                {op.name}
                                                            </Button>
                                                        ))}
                                                    </>
                                                )}

                                                {firstCol && selectedOperator && (
                                                    <>
                                                        <p><strong>Step 3: {getStepThreeTitle()}</strong></p>
                                                        <div className="mb-2">
                                                            <small className="text-muted">
                                                                Preview: <code>{generateExpressionPreview()}</code>
                                                            </small>
                                                        </div>
                                                        {renderParameterSelection()}
                                                    </>
                                                )}
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer style={{ borderTop: 'none' }}>
                                            <Button variant="btn btn-sm btn-outline-secondary" onClick={clearSelections}>
                                                Clear
                                            </Button>
                                            <Button variant="btn btn-sm btn-outline-primary" onClick={handleOkClick1}>
                                                OK
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>

                                    <Modal show={modalMessage} onHide={handleModalClose} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                        <div
                                            className={`alert alert-${messageType === 'success'
                                                ? 'success'
                                                : messageType === 'warning'
                                                    ? 'warning'
                                                    : 'danger'
                                                } alert-dismissible fade show`}
                                            role="alert"
                                            style={{ marginBottom: '0' }}
                                        >
                                            <div className="d-flex align-items-center">
                                                {messageType === 'success' ? (
                                                    <span className="me-2" style={{ color: 'green' }}>✅</span>
                                                ) : messageType === 'warning' ? (
                                                    <span className="me-2" style={{ color: 'orange' }}>⚠️</span>
                                                ) : (
                                                    <span className="me-2" style={{ color: 'red' }}>❌</span>
                                                )}

                                                <p
                                                    style={{
                                                        display: 'inline',
                                                        marginBottom: '0px',
                                                        fontSize: '14px',
                                                        color:
                                                            messageType === 'success'
                                                                ? 'green'
                                                                : messageType === 'warning'
                                                                    ? 'orange'
                                                                    : 'red' // Change text color based on messageType
                                                    }}
                                                >
                                                    {/* {modalMessage} */}
                                                    <div dangerouslySetInnerHTML={{ __html: modalMessage }} />

                                                </p>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={handleModalClose}
                                                style={{
                                                    width: '15px',
                                                    height: '15px',
                                                    fontSize: '8px',
                                                    position: 'absolute',
                                                    bottom: '10px',
                                                    right: '10px',
                                                }}
                                            ></button>
                                        </div>
                                    </Modal>

                                    <Modal show={showNoRecordsModal} onHide={() => setShowNoRecordsModal(false)} style={{ marginTop: '12vh' }}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>No Records Found</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>No records match your search criteria.</Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary"
                                                style={closeButtonStyle}
                                                onClick={() => setShowNoRecordsModal(false)}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                    {showConfirmationModal && (

                                        <Modal
                                            show={showConfirmationModal}
                                            onHide={() => setShowConfirmationModal(false)}
                                            keyboard={false}
                                            style={{ marginTop: '12vh' }}
                                        >
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                            >
                                                <Modal.Title style={{ fontSize: '16px' }}>
                                                    Confirm Action
                                                </Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body
                                                style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                            >
                                                Do you wish to Modify and Save the Template with a New name?
                                            </Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button
                                                    style={{
                                                        backgroundColor: '#ffc107',
                                                        borderColor: '#ffc107',
                                                        color: 'black',
                                                        ...submitButtonStyle
                                                    }}
                                                    onClick={handleConfirmYes}
                                                >
                                                    Yes
                                                </Button>
                                                <Button
                                                    style={cancelButtonStyle}
                                                    variant="secondary"
                                                    onClick={handleConfirmNo}
                                                >
                                                    No
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>

                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyMet;
